/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.roles.permissions.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.factory.notice',
  'acme.view.application.roles.permissions.addModal.controllers',
  'acme.view.application.roles.permissions.removeModal.controllers',
  'acme.common.factory.gridState'
])

.controller('RolesPermissionsController', ['$scope', '$state', '$timeout', '$uibModal', 'ApiService', 'NoticeFactory', 'RoleData', 'GridStateFactory', function($scope, $state, $timeout, $uibModal, ApiService, NoticeFactory, RoleData, GridStateFactory) {

    $scope.rolesPermissions = {

      model: [],
      addModal: {},
      removeModal: {},
      role: {},
      gridState: new GridStateFactory(),

      isLoaded: false,

      notice: new NoticeFactory(),

      grid: {
        pageSize: 50,
        showFooter: true,
        paginate: true,
        multiselect: false,
        enableRowSelection: false,
        useExternalPagination: true,
        useExternalSorting: true,
        columns: [
          {
            field: 'name',
            displayName: 'Name'
          },
          {
            field: 'displayName',
            displayName: 'Display Name'
          },
          {
            field: 'remove',
            displayName: 'Remove',
            onCellNavClick: function(row, col) {
              $scope.rolesPermissions.remove(row.entity.id);
            },
            enableSorting: false,
            enableHiding: false,
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.remove(row.entity.id)" role="button">Remove<span class="sr-only">-Opens a dialog</span></a></div>'
          }
        ]
      },

      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Role Permissions',
          buttonRight: {
            label: 'Add Permissions',
            permissions: 'ROLES_UPDATE',
            action: function() {
              $scope.rolesPermissions.add();
            }
          }
        });

        this.gridState.updateGridState(null, this.grid.pageSize, 'name', 'asc');

        this.getPermissions($state.params.id);

        if (RoleData.data && RoleData.data.success) {
          this.success.init(RoleData);
        }else{
          this.error.init(RoleData);
        }

      },

      getPermissions: function(id) {
        ApiService.roles.permissions.list(id, this.gridState.getGridState()).then(this.success.getPermissions, this.error.getPermissions);
      },

      findPermission: function(id) {

        var i, ii,
          r = false;

        for (i=0,ii=this.model.length;i<ii;i++) {
          if (this.model[i].id === id) {
            r = {
              permission: this.model[i],
              index: i
            };
          }
        }

        return r;

      },

      getPermissionsIds: function() {
        var i, ii,
            ids = [];

        for (i=0,ii=this.model.length;i<ii;i++) {
          ids.push(this.model[i].rolePermissionMapId);
        }

        return ids;
      },

      addBatch: function(list) {

        ApiService.roles.permissionMaps.batchCreate({ mappings: list.mappings }).then(function(response, status, headers, config) {
          var i, ii,
            j, jj,
            self = $scope.rolesPermissions,
            mappings = response.data.payload;

          // Remap userGroupMapIds to model for deletions to work
          for (i=0,ii=mappings.length;i<ii;i++) {
            for (j=0,jj=list.permissions.length;j<jj;j++) {
              if (mappings[i].permissionId === list.permissions[j].id) {
                list.permissions[j].rolePermissionMapId = mappings[i].id;
              }
            }
          }
          self.model = list.permissions;
          self.success.addBatch(response, status, headers, config);
        }, this.error.addBatch);

      },

      add: function() {
        var self = $scope.rolesPermissions;

        self.addModal = $uibModal.open({
          templateUrl: 'views/application/views/roles/permissions/modals/addPermissions.tpl.html',
          size: 'md',
          controller: 'RolesPermissionsAddModalController',
          resolve: {
            roleData: function() {
              return self.role;
            },
            rolePermissions: function() {
              return self.model;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.addModal.result.then(function (list) {
          var ids = self.getPermissionsIds();
          if (ids.length > 0) {
            ApiService.roles.permissionMaps.remove({ ids: ids }).then(function (response) {
              self.addBatch(list);
            }, self.error.add);
          }else{
            self.addBatch(list);
          }
        }, function () {
          // Do nothing
        });
      },

      remove: function(id) {
        var self = $scope.rolesPermissions,
            found = self.findPermission(id);

        self.removeModal = $uibModal.open({
          templateUrl: 'views/application/views/roles/permissions/modals/removePermission.tpl.html',
          size: 'md',
          controller: 'RolesPermissionsRemoveModalController',
          resolve: {
            currentPermission: function() {
              return found.permission;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.removeModal.result.then(function () {
          ApiService.roles.permissionMaps.remove({ ids: [found.permission.rolePermissionMapId] }).then(function(response, status, headers, config) {
            self.model.splice(found.index, 1);
            self.success.remove(response, status, headers, config);
          }, function(response, status, headers, config) {
            self.error.remove(response, status, headers, config);
          });
        }, function () {
          // Do nothing
        });
      },

      success: {
        init: function(response) {
          var self = $scope.rolesPermissions;
          self.role = response.data.payload;
        },
        getPermissions: function(response) {
          var self = $scope.rolesPermissions;
          //next tick
          $timeout(function() {
            self.model = response.data.payload.list;
            self.gridState.setPropertyValue('totalItems', response.data.payload.pagination.count);
            self.isLoaded = true;
          }, 0);
        },
        add: function(response) {},
        addBatch: function(response) {},
        remove: function(response) {}
      },

      error: {
        init: function(response) {},
        getPermissions: function(response) {
          var self = $scope.rolesPermissions;
          self.isLoaded = true;
        },
        add: function(response) {},
        addBatch: function(response) {},
        remove: function(response) {}
      },

      onDataGridPaginate: function(newPage, pageSize) {
        var self = $scope.rolesPermissions;
        self.gridState.updateGridState(newPage, pageSize);
        self.getPermissions(self.role.id);
      },

      onDataGridSortChange: function(grid, columns) {
        var self = $scope.rolesPermissions, data = columns[0];
        if(data) {
          self.gridState.updateGridState(null, null, data.field, data.sort.direction);
          self.getPermissions(self.role.id);
        }
      }


    };

    $scope.rolesPermissions.init();

}]);